import { initLenis } from './global/lenis.js';
import { setViewportUnits, scrollToHash, initHeaderHeight, initLegalSymbols, EditableSvg } from './utils/utilities.js';

export async function initComponents() {
    setViewportUnits();
    scrollToHash();
    initHeaderHeight();
    initLegalSymbols();
    document.querySelectorAll('.editable-svg').forEach((img) => EditableSvg(img));
    initLenis();

    // globals
    const header = document.querySelector('.site-header');
    const offcanvas = document.querySelector('.offcanvas');
    const hasDropdowns = Boolean(document.querySelector('.is-dropdown'));

    // blocks
    const hasTimelines = Boolean(document.querySelector('.wp-block-ssm-timeline'));
    const hasAccordions = Boolean(document.querySelector('.wp-block-ssm-accordion'));
    const hasProductFeeds = Boolean(document.querySelector('.wp-block-ssm-product-feed'));
    const hasStats = Boolean(document.querySelector('.js-counter'));
    const hasProductComponents = Boolean(document.querySelector('.wp-block-ssm-product-components-slider'));
    const hasTableOfContents = Boolean(document.querySelector('.wp-block-list.is-style-table-of-contents'));
    const hasCategoryLists = Boolean(document.querySelector('.wp-block-ssm-category-list'));
    const hasProductGalleries = Boolean(document.querySelector('.wp-block-ssm-product-featured-image-gallery'));
    const hasFormBlocks = Boolean(document.querySelector('.gform_wrapper, .gform_confirmation_wrapper'));
    const hasVideos = Boolean(document.querySelector('.wp-block-video, .wp-block-embed'));
    const hasLogoWalls = Boolean(document.querySelector('.wp-block-ssm-logo-wall'));
    const hasTestimonials = Boolean(document.querySelector('.wp-block-ssm-testimonials'));
    const hasScrollAnimations = Boolean(document.querySelector('.scroll-animation-wrapper'));

    const results = await Promise.allSettled(
        [
            header && import('./global/header.js').then(({ Header }) => Header(header)),
            offcanvas && import('./global/offcanvas.js').then(({ Offcanvas }) => new Offcanvas(offcanvas)),
            offcanvas && import('./global/offcanvasNavigation.js').then(({ OffcanvasNavigation }) => OffcanvasNavigation()),
            hasDropdowns && import('./global/dropdownMenu.js').then(({ DropdownMenu }) => DropdownMenu()),
            hasTimelines && import('./blocks/timeline.js').then(({ Timeline }) => Timeline()),
            hasAccordions && import('./blocks/accordion.js').then(({ Accordion }) => Accordion()),
            hasProductFeeds && import('./blocks/product-feed.js').then(({ productFeed }) => productFeed()),
            hasStats && import('./blocks/stats.js').then(({ Stats }) => Stats()),
            hasProductComponents && import('./blocks/single-product-hero.js').then(({ ProductComponents }) => ProductComponents()),
            hasTableOfContents && import('./blocks/list.js').then(({ TableOfContentsList }) => TableOfContentsList()),
            hasCategoryLists && import('./blocks/category-list.js').then(({ CategoryList }) => CategoryList()),
            hasProductGalleries && import('./blocks/product-featured-image-gallery.js').then(({ ProductFeaturedImageGallery }) => ProductFeaturedImageGallery()),
            hasFormBlocks && import('./blocks/form.js').then(({ Form }) => Form()),
            hasVideos && import('./blocks/video.js').then(({ Video }) => Video()),
            hasLogoWalls && import('./blocks/logo-wall.js').then(({ LogoWall }) => LogoWall()),
            hasTestimonials && import('./blocks/testimonials.js').then(({ Testimonials }) => Testimonials()),
            hasScrollAnimations && import('./blocks/scroll-animation.js').then(({ ScrollAnimation }) => ScrollAnimation()),
        ].filter(Boolean),
    );

    return results
        .filter((r) => {
            if (r.status === 'rejected') console.error('[initComponents] Module failed to load:', r.reason);
            return r.status === 'fulfilled';
        })
        .map((r) => r.value)
        .flat();
}

document.addEventListener('DOMContentLoaded', initComponents);

import.meta.glob([
    '../../images/**',
    '!../../images/cms/**',
    '../../fonts/**',
]);
